// extracted by mini-css-extract-plugin
module.exports = {"container":"LongToolTip_container__iwRRl","red":"LongToolTip_red__2IA7H","yellow":"LongToolTip_yellow__14hkF"};